import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:false,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [


			{
				"title": "Ayelet Tours, Ltd.",
				"link": "https://ayelet.com/holy-land-tours/",
				"price": " $1,540",
				"desc":"Holy Land - 7 or 10 nights including holy and historic sights,from Jerusalem to the Galilee!",
				"logo":"/Deals/AyeletLogo_Blue_2017.jpg",
				"book_now" : "BOOK NOW"
			},
					{
				"title": "Ayelet Tours, Ltd.",
				"link": "https://ayelet.com/ayelet-platinum/",
				"price": " $3,400",
				"desc":"Israel PLATINUM - Private touring with expert advice",
				"logo":"/Deals/AyeletLogo_Blue_2017.jpg",
				"book_now" : "BOOK NOW"
			},
							{
				"title": "Ayelet Tours, Ltd.",
				"link": "https://ayelet.com/israel-bar-mitzvah-tours/",
				"price": " $3,999 (land)",
				"desc":"Bar or Bat Mitzvah in Israel",
				"logo":"/Deals/AyeletLogo_Blue_2017.jpg",
				"book_now" : "BOOK NOW"
			}

	

  	]

  }

  render() {

  	const dealsHtml = this.deals.map((o)=>{
  		return <DealItem 
		            key={ o.title } 
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js